import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUS_META = {
  pending:   { label: "Pending", color: "#fbbf24" },
  filled:    { label: "Filled",  color: "#4ade80" },
  failed:    { label: "Failed",  color: "#ef4444" },
  cancelled: { label: "Cancelled", color: "#8b949e" },
};

export default function OrderQueueCard() {
  const [queue, setQueue] = useState([]);

  const load = () => {
    axios.get(`${API}/order/queue?limit=20`).then(r => setQueue(r.data?.queue || [])).catch(() => {});
  };
  useEffect(() => { load(); const iv = setInterval(load, 8000); return () => clearInterval(iv); }, []);

  const cancel = async (qid) => {
    try { await axios.post(`${API}/order/queue/${qid}/cancel`); load(); } catch (_) {}
  };

  return (
    <div className="card" data-testid="order-queue-card" style={{ borderColor: "rgba(251,191,36,0.25)" }}>
      <div className="sh" style={{ marginBottom: 10, display: "flex", alignItems: "center", gap: 8 }}>
        Order Queue
        <span className="tag" style={{ fontSize: 8, background: "rgba(251,191,36,0.14)", color: "#fbbf24", padding: "2px 6px", borderRadius: 4 }}>AUTO-RETRY</span>
        {queue.length > 0 && <span style={{ fontSize: 10, color: "var(--dim)", marginLeft: "auto" }}>{queue.length} total</span>}
      </div>
      <div style={{ fontSize: 10, color: "var(--dim)", marginBottom: 10 }}>
        Failed orders auto-retry every 20s with fresh pricing (options) and min-$1 upscale (crypto). Max 5 attempts.
      </div>
      {queue.length === 0 ? (
        <div style={{ textAlign: "center", padding: 14, color: "var(--dim)", fontSize: 11 }}>No queued orders</div>
      ) : queue.map(q => {
        const m = STATUS_META[q.status] || STATUS_META.pending;
        const p = q.params || {};
        return (
          <div key={q.queue_id} data-testid={`queue-row-${q.queue_id}`} style={{ padding: 10, borderRadius: 8, background: "var(--layer2)", borderLeft: `3px solid ${m.color}`, marginBottom: 6 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "var(--text)" }}>
                  {p.side} {p.quantity} {p.symbol}
                  <span style={{ marginLeft: 8, padding: "1px 6px", borderRadius: 4, fontSize: 9, background: m.color + "22", color: m.color, fontWeight: 700 }}>{m.label}</span>
                </div>
                <div style={{ fontSize: 10, color: "var(--dim)", marginTop: 2 }}>@ ${p.limitPrice} · {p.instrumentType}</div>
                {q.lastError && <div style={{ fontSize: 10, color: "#f87171", marginTop: 4 }}>{q.lastError}</div>}
                {q.adjusted && (q.adjusted.quantity !== p.quantity || q.adjusted.limitPrice !== p.limitPrice) && (
                  <div style={{ fontSize: 10, color: "#60a5fa", marginTop: 2 }}>
                    Adjusted → qty {q.adjusted.quantity} @ ${q.adjusted.limitPrice}
                  </div>
                )}
                <div style={{ fontSize: 9, color: "var(--dim)", marginTop: 2 }}>Attempts: {q.attempts || 0}/5</div>
              </div>
              {q.status === "pending" && (
                <button data-testid={`queue-cancel-${q.queue_id}`} onClick={() => cancel(q.queue_id)} style={{ padding: "4px 10px", borderRadius: 10, border: "1px solid rgba(239,68,68,0.4)", background: "transparent", color: "#f87171", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>Cancel</button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
